import { ExpandedTooltip, Icon } from '@livable/saas-react-components';
import { IconButton } from '@mui/material';
import React from 'react';
import { SubscriptionTierBadge } from 'src/components/SubscriptionTier';

// The AP Push switch's info icon: 20px inside the theme's small icon button.
const INFO_BUTTON = {
  padding: '2px',
  '& .MuiSvgIcon-root': {
    width: '20px',
    height: '20px'
  }
};

// property-service answers errors in PascalCase: { Error: { ErrorCode, GeneralErrorMessage } }.
export const messageOf = (err, fallback) => {
  var _err$response;
  const message = err === null || err === void 0 || (_err$response = err.response) === null || _err$response === void 0 || (_err$response = _err$response.data) === null || _err$response === void 0 || (_err$response = _err$response.Error) === null || _err$response === void 0 ? void 0 : _err$response.GeneralErrorMessage;
  return typeof message === 'string' && message.length <= 300 ? message : fallback;
};
export const sameId = (a, b) => !!a && !!b && String(a).toLowerCase() === String(b).toLowerCase();
export const Tip = _ref => {
  let label = _ref.label,
    text = _ref.text;
  return /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: text,
    placement: "top",
    describeChild: true
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    "aria-label": "About ".concat(label),
    sx: INFO_BUTTON
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "info",
    state: "info"
  })));
};

/** A plan the company isn't on yet, with what it includes behind its badge's info icon. */
export const Needs = _ref2 => {
  let tier = _ref2.tier,
    className = _ref2.className;
  return /*#__PURE__*/React.createElement("span", {
    className: className
  }, "Needs ", /*#__PURE__*/React.createElement(SubscriptionTierBadge, {
    tier: tier
  }));
};